<template>
<div>
  <span class="d-flex mx-4 my-4">
    <v-btn
      color="primary"
      class="white--text mt-1 py-6"
      @click="navigateBack()">
      <v-icon large>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer />
    <div class="mt-2 text-h5 text-center">{{ docName }}</div>
    <v-spacer />
  </span>
  <vue-pdf-app style="height: 80vh;" :pdf="pdf" :title="false" :config="config"></vue-pdf-app>
</div>
</template>

<script>
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css"; //use default icons for buttons

export default {
  components: {
    VuePdfApp
  },
  data() {
    return {
      config: {
        toolbar: {
          toolbarViewerLeft: { findbar: true }
        }
      },
      docName: null,
      pdf: null
    };
  },
  created() {
    this.docName = this.$route.params.docName;
    switch (this.docName)
    {
      case 'Installation Instructions':
        this.pdf = require("@/assets/docs/Installation-Instructions.pdf").default;
        break;
      case 'Release Notes':
        this.pdf = require("@/assets/docs/Release-Notes.pdf").default;
        break;
      case 'Configuring Backup System':
        this.pdf = require("@/assets/docs/Configuring-Backup-System.pdf").default;
        break;
    }
  },
  methods: {
    navigateBack() {
       this.$router.go(-1);
    },
  }
}
</script>
<style>
/* Overide pdf z-index values. This is to keep gba sidebar on top. */
.pdf-app .toolbar { /* Override pdf default toolbar z-index. */
  z-index: 5 !important;
}
.pdf-app #sidebarContainer { /* override pdf sidebar z-index. Make less than toolbar. */
  z-index: 4 !important;
}
</style>